export const convertUTCDateToTime = (utcTime: string) => {
    if (!utcTime) return '';
    const localDate = new Date(utcTime);
    // Get only time (e.g., "9:30 AM")
    const options: any = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    };

    const localTime = localDate.toLocaleTimeString(undefined, options);
    return localTime;
}
